import { useRef } from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'

import { observer } from 'mobx-react'

import useVirtualization from 'modules/core/hooks/useVirtualization'
import i18n from 'modules/core/lib/i18n'

import GradientShadow from 'modules/payroll_bundle/components/GradientShadow'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

import Item from './Item'

const ITEM_HEIGHT = 73
const SHADOW_HEIGHT_MULTIPLIER = 1.1

interface Props {
  items: PaymentItem[]
  checkable: boolean
  onSelectItem: (paymentItem: PaymentItem) => void
  selected: Set<number>
}

const GroupBody = ({ items, checkable, onSelectItem, selected }: Props) => {
  const colSpan = 6

  const containerRef = useRef<HTMLDivElement>(null)

  const {
    visibleStartIndex,
    endIndex,
    topPlaceholderHeight,
    bottomPlaceholderHeight,
    scrollTopShadow,
    scrollBottomShadow,
  } = useVirtualization({
    items: items,
    defaultItemHeight: ITEM_HEIGHT,
    containerRef,
    shadowHeight: ITEM_HEIGHT * SHADOW_HEIGHT_MULTIPLIER,
  })

  if (!items.length) {
    return (
      <Table.Body>
        <Table.Blank
          colSpan={colSpan}
          text={i18n.t('payroll_bundle.results_payments.payments.table.no_employees')}
        />
      </Table.Body>
    )
  }

  return (
    <Box
      ref={containerRef}
      flexGrow
      position="relative"
      maxHeight="s400"
      overflowX="auto"
      overflowY="auto"
    >
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
        }}
      >
        <AnimatePresence>
          {scrollTopShadow && <GradientShadow direction="bottom" height={400} />}
        </AnimatePresence>
        <AnimatePresence>
          {scrollBottomShadow && <GradientShadow direction="top" height={400} />}
        </AnimatePresence>
      </div>

      <Box
        style={{
          height: `${topPlaceholderHeight}px !important`,
          minHeight: `${topPlaceholderHeight}px`,
          maxHeight: `${topPlaceholderHeight}px`,
        }}
      ></Box>
      <Table noRadius hideBorder overflowY="unset">
        {items.slice(visibleStartIndex, endIndex).map((paymentItem) => {
          return (
            <Item
              key={paymentItem.id}
              checkable={checkable}
              paymentItem={paymentItem}
              onSelectItem={onSelectItem}
              selected={selected}
            />
          )
        })}
      </Table>
      <Box
        style={{
          height: `${bottomPlaceholderHeight}px`,
          minHeight: `${bottomPlaceholderHeight}px`,
          maxHeight: `${bottomPlaceholderHeight}px`,
        }}
      ></Box>
    </Box>
  )
}

export default observer(GroupBody)
